module.exports = __webpack_public_path__ + "73fc6fa8b35bef679a67ef94cbf34461.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-banner-snowhite.svg
// module id = 472
// module chunks = 0